import { WistiaIcon } from '../../../assets/icons/wistia';
import { createEmbedProvider } from '../factory';

/**
 * Consolidated regex for input rules (matches all WISTIA_PATTERNS)
 * Includes invisible char handling for paste support.
 * @internal Exported for input-rules/wistia.ts
 */
export const WISTIA_INPUT_REGEX =
  /(?:https?:\/\/)?(?:fast\.wistia\.(?:com|net)\/embed\/(?:iframe|medias)\/|[a-zA-Z0-9_~-]+\.wistia\.com\/medias\/)([a-zA-Z0-9_~-]+)(?:\/[^\s?]*)?(?:\?[^\s]*)?[\u200B-\u200D\uFEFF\u00AD]*$/i;

export const wistiaProvider = createEmbedProvider({
  id: 'wistia',
  label: 'Wistia Video',
  icon: <WistiaIcon className="size-5 fill-current" />,
  regex: WISTIA_INPUT_REGEX,
  buildEmbedUrl: (match) => `https://fast.wistia.com/embed/iframe/${match[1]}`,
});
